import { Link } from "react-router-dom";
import React, { FC, ReactNode } from "react";
import { IconKeyboardArrowRightBlue } from "assets/svg";

export interface BreadcrumbItem {
  label: string | ReactNode;
  link?: string;
  isCurrent?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const CustomBreadCrumb: FC<BreadcrumbProps> = ({ items }) => {
  return (
    <div className="hidden self-stretch md:inline-flex justify-start items-center gap-[5px]">
      {items.map((item, index) => (
        <div
          key={index}
          data-プロパティ1={item.isCurrent ? "current" : "base"}
          className="flex justify-start items-center gap-[5px]"
        >
          {item.link && !item.isCurrent ? (
            <Link
              to={item.link}
              className="justify-start text-primary text-[13px] font-normal font-['Noto_Sans_JP'] underline leading-tight"
            >
              {item.label}
            </Link>
          ) : (
            <div className="justify-start text-black text-[13px] font-normal font-['Noto_Sans_JP'] underline leading-tight">
              {item.label}
            </div>
          )}
          {!item.isCurrent && (
            <IconKeyboardArrowRightBlue className="w-[16px] h-[16px] aspect-[1/1]" />
          )}
        </div>
      ))}
    </div>
  );
};

export default CustomBreadCrumb;
